import { DefaultTheme } from 'styled-components'
import { ThemeEnum, ITheme } from '../interfaces/styled'

const baseTheme: ITheme = {
  colors: {
    navBackground: '#CCE5FF',
    navMainBackground: '',
    primaryBackground: '#F7F4F5',
    primaryBackgroundUrl: '',
    secondaryBackground: 'rgba(255, 255, 255, 0.6)',
    secondaryBackgroundNT: '',
    thirdlyBackground: '',
    footerBackground: '#F7F4F5',
    footerSocialLinkHover: '',
    cardBorderColor: '',
    backgroundColor1: '',
    scrollTopButtonBackground: '',
    scrollTopButtonBackgroundHover: '',
    scrollTopButtonBackgroundBorder: '',

    primary: '#7986cb',
    primaryDark: '#5c6bc0',
    primaryLight: '#9fa8da',
    secondary: '#2b2b2b',
    secondaryDark: '#1f1f1f',
    secondaryLight: '#383838',
    success: '#4caf50',
    successDark: '#43a047',
    successLight: '#66bb6a',
    danger: '#f44336 ',
    dangerDark: '#e53935',
    dangerLight: '#ef5350 ',

    white: '#E5E4E8',
    black: '#19191B',
    red: '#B3376C',
    darkRed: '#792247',
    accent: '#00637B',
    
    error: '#f46666',
    overlay: '#383838',

    bg: '#E5E4E8',
    primaryFont: '#19191B',
    secondaryFont: '',
    navFont: '',
    navLogoFont: '',
    navFontHover: '',
    navFontBackHover: '',
    title: '',
    text: ''
  },

  font: {
    family: 'Open Sans',
    primaryFont: 'Open Sans',
    secondaryFont: 'Roboto'
  },

  media: {
    // Мои
    // extraLarge: '(min-width: 1140px)',
    // large: '(min-width: 960px)',
    // medium: '(min-width: 768px)',
    // small: '(min-width: 576px)',
    // extraSmall: '(max-width: 576px)',

    // Source: https://www.w3schools.com/css/css_rwd_mediaqueries.asp#
    ultraLarge: '(min-width: 1400px)',
    extraLarge: '(min-width: 1200px)',
    large: '(min-width: 992px)',
    medium: '(min-width: 768px)',
    small: '(min-width: 600px)',
    extraSmall: '(max-width: 600px)',

    // Source: https://getbootstrap.com/docs/4.0/layout/grid/
    // extraLarge: '(max-width: 1140px)',
    // large: '(max-width: 960px)',
    // medium: '(max-width: 720px)',
    // small: '(max-width: 540px)',
    // extraSmall: '(max-width: 540px)'
  },

  // in px
  sizes: {
    header: { height: 56 },
    container: { width: 1200 },
    footer: { height: 128 },
    modal: { width: 540 },
  },

  // in ms
  durations: {
    ms300: 300,
  },

  // z-index
  order: {
    header: 50,
    modal: 100,
  },

  business: {
    colors: {
      primary: 'rgba(0, 99, 123, 1)',
      primaryBackground: '',
      titleColor: '',      
      textColor: '',
      navBackground: '',
      footerBackground: '',
      cardBackground1: '',
      cardBackground2: '',
      cardBackground3: '',
      bannerInfoBackground: '',
      bannerPhoneHintBg: '',
      sliderBorderColor: '',
      sliderBackground: '',

      tariffBase: '',
      tariffPro: '',
      tariffEnterprise: '',

      storyBackground: '',

      functionalTabItemActiveColor: '',
      functionalTabItemActiveBackground: '',
      functionalTabItemColor: '',
      functionalTabItemBackground: '',
      functionalRateCellColor: '',
      functionalRateCellBackground: '',

      feedbackFormInputBackground: '',
      feedbackFormInputBorder: '',

      aboutImageBackground: ''
    }
  }
}


export const lightTheme: DefaultTheme = {
  ...baseTheme,
  type: ThemeEnum.light,

  colors: {
    ...baseTheme.colors,
    navBackground: '#F7F4F5',
    navMainBackground: '#CCE5FF',
    primaryBackground: '#F7F4F5',
    primaryBackgroundUrl: 'back2.png',
    secondaryBackground: 'rgba(255, 255, 255, 0.6)',
    secondaryBackgroundNT: 'rgb(255, 255, 255)',
    thirdlyBackground: 'rgba(255, 255, 255, 0.50)',
    footerBackground: '#F7F4F5',
    footerSocialLinkHover: '#000000',
    cardBorderColor: 'rgba(0, 0, 0, 0.1)',
    scrollTopButtonBackground: 'rgba(255, 255, 255, 0.7)',
    scrollTopButtonBackgroundHover: 'linear-gradient(0deg, #FFFFFF, #FFFFFF), linear-gradient(181.3deg, rgba(255, 255, 255, 0.7) 1.11%, rgba(189, 126, 153, 0.35) 127%)',
    scrollTopButtonBackgroundBorder: 'linear-gradient(181.3deg, rgba(255, 255, 255, 0.7) 1.11%, rgba(189, 126, 153, 0.35) 127%)',
    bg: '#E5E4E8',
    primaryFont: '#151515',
    secondaryFont: '#3D3136',
    navFont: '#151515',
    navLogoFont: 'rgba(61, 49, 54, 1)',
    navFontHover: '#000000',
    navFontBackHover: '#FFFFFF66',
    title: '#000',
    text: '#151515'
  },

  business: {
    colors: {
      ...baseTheme.business.colors,
      primaryBackground: 'rgb(226, 226, 226)',
      titleColor: '#000000',
      textColor: '#151515',
      navBackground: '#E2E2E2',
      footerBackground: 'rgba(247, 244, 245, 1)',
      cardBackground1: '#FFFFFF',
      cardBackground2: '#FFFFFF99',
      cardBackground3: '#FFFFFFE5',
      bannerInfoBackground: 'rgba(255, 255, 255, 0.5)',
      bannerPhoneHintBg: 'rgba(255, 255, 255, 0.7)',
      sliderBorderColor: 'rgba(0, 0, 0, 0.2)',
      sliderBackground: 'rgba(255, 255, 255, 0.5)',

      tariffBase: 'rgba(43, 153, 107, 1)',
      tariffPro: 'rgba(0, 99, 123, 1)',
      tariffEnterprise: 'rgba(82, 64, 152, 1)',

      storyBackground: 'rgba(255, 255, 255, 0.6)',

      functionalTabItemActiveColor: 'rgba(0, 99, 123, 1)',
      functionalTabItemActiveBackground: 'rgba(255, 255, 255, 0.8)',
      functionalTabItemColor: 'rgba(21, 21, 21, 0.8)',
      functionalTabItemBackground: 'rgba(255, 255, 255, 0.4)',

      functionalRateCellColor: 'rgba(21, 21, 21, 1)',
      functionalRateCellBackground: 'rgba(255, 255, 255, 0.4)',

      feedbackFormInputBackground: '#FFFFFF',
      feedbackFormInputBorder: 'rgba(0, 0, 0, 0.2)',

      aboutImageBackground: 'rgba(0, 99, 123, 0.1)'
    }
  }
}

export const darkTheme: DefaultTheme = {
  ...baseTheme,
  type: ThemeEnum.dark,

  colors: {
    ...baseTheme.colors,
    navBackground: '#F7F4F5',
    navMainBackground: '#2a2442',
    primaryBackground: '#1E1E1E',
    primaryBackgroundUrl: 'back3.png',
    secondaryBackground: 'rgba(48, 48, 48, 0.60)',
    secondaryBackgroundNT: 'rgb(40, 42, 53)',
    thirdlyBackground: 'rgba(48, 48, 48, 0.50)',
    footerBackground: 'rgba(30, 30, 30, 1)',
    footerSocialLinkHover: '#FFFFFF',
    cardBorderColor: 'rgba(255, 255, 255, 0.1)',
    scrollTopButtonBackground: 'rgba(48, 48, 48, 0.5)',
    scrollTopButtonBackgroundHover: 'rgba(48, 48, 48, 1)',
    scrollTopButtonBackgroundBorder: 'linear-gradient(181.3deg, rgba(48, 48, 48, 0.7) 1.11%, rgba(189, 126, 153, 0.35) 127%)',
    bg: '#19191B',
    primaryFont: '#EAEAEA',
    secondaryFont: '#E0E0E0',
    navFont: '#E0E0E0',
    navLogoFont: '#E0E0E0',
    navFontHover: '#FFFFFF',
    navFontBackHover: '#00000066',
    title: '#FFF',
    text: '#E0E0E0'
  },

  business: {
    colors: {
      ...baseTheme.business.colors,
      primaryBackground: 'rgb(30, 30, 30)',
      titleColor: '#FFFFFF',
      textColor: '#E0E0E0',
      navBackground: '#3D3D3D',
      footerBackground: 'rgba(48, 48, 48, 0.5)',
      cardBackground1: '#303030',
      cardBackground2: '#30303099',
      cardBackground3: '#303030E5',
      bannerInfoBackground: 'rgba(255, 255, 255, 0.5)',
      bannerPhoneHintBg: 'rgba(48, 48, 48, 0.7)',
      sliderBorderColor: 'rgba(255, 255, 255, 0.2)',
      sliderBackground: 'rgba(48, 48, 48, 0.5)',

      tariffBase: 'rgba(43, 153, 107, 1)',
      tariffPro: 'rgba(0, 99, 123, 1)',
      tariffEnterprise: 'rgba(82, 64, 152, 1)',

      storyBackground: 'rgba(48, 48, 48, 0.6)',

      functionalTabItemActiveColor: 'rgba(0, 99, 123, 1)',
      functionalTabItemActiveBackground: 'rgba(48, 48, 48, 0.8)',
      functionalTabItemColor: 'rgba(224, 224, 224, 0.8)',
      functionalTabItemBackground: 'rgba(48, 48, 48, 0.4)',

      functionalRateCellColor: 'rgba(224, 224, 224, 1)',
      functionalRateCellBackground: 'rgba(48, 48, 48, 0.4)',

      feedbackFormInputBackground: 'linear-gradient(0deg, rgba(30, 30, 30, 0.8), rgba(30, 30, 30, 0.8)), linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1))',
      feedbackFormInputBorder: 'rgba(255, 255, 255, 0.1)',

      aboutImageBackground: 'rgba(0, 99, 123, 0.1)'
    }
  }
}